import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { ContactService } from 'src/app/services/contact.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss']
})
export class HealthComponent implements OnInit {
  healt = ContentPage.esES.health;
  healthForm: FormGroup;
  textError: string = "";

  constructor(
    private contactservice: ContactService,
    private router: Router,
    private dialogRef: MatDialogRef<HealthComponent>,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.healt = language == 'esEN' ? ContentPage.esEN.health : ContentPage.esES.health;
    }
    this.formBuilder();
  }

  changeSelected(option){
    let options = this.healt.subtitles[1].placeholders;
    options.forEach((element)=>{
      element.selected = false;
    })
    option.selected = true;
    this.healthForm.controls.ocupation.setValue(option.label);
  }

  formBuilder(){
    this.healthForm = new FormGroup({
      name: new FormControl('', Validators.required),
      lastname: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      country: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      ocupation: new FormControl('', Validators.required),
      checked: new FormControl(false),
    })
  }

  saveForm(){
    if (!this.healthForm.valid) {
      this.textError = "Debe completar todos los campos oblitagorios con asterisco.";
      return
    }
    this.textError = "";
    this.spinner.show();
    this.contactservice.saveForm(this.healthForm.value).subscribe(
      (response)=>{
        if (response.ok) {
          this.dialogRef.close(true);
          this.dialog.open(AlertComponent,{
            autoFocus: false,
            width: '700px',
            data: {
              title: '¡Mensaje enviado con éxito!',
              text: 'El mensaje fue enviado correctamente, a la brevedad se contactará un representante.',
              textButton: 'Entendido'
            }
          });
        }
      },
      ()=>{},
      ()=>{
        this.spinner.hide();
      }
    );
  }

}
